import { useMediaQuery } from '@/hooks/useMediaQuery';

/** True if the visitor has requested reduced motion at the OS/browser level. */
export function useReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)');
}
